const RESERVED_PREFIXES = ["firebase_", "google_", "ga_"] as const;

const EVENT_NAME_REGEX = /^[a-z][a-z0-9_]{0,39}$/;
const PARAM_KEY_REGEX = /^[a-z][a-z0-9_]{0,39}$/;

export type EventNameValidationResult = {
  valid: boolean;
  reason?: string;
};

export function validateAnalyticsEventName(eventName: string): EventNameValidationResult {
  if (!EVENT_NAME_REGEX.test(eventName)) {
    return {
      valid: false,
      reason:
        "Event name must be snake_case, start with a lowercase letter, and be <= 40 chars.",
    };
  }

  if (RESERVED_PREFIXES.some((prefix) => eventName.startsWith(prefix))) {
    return {
      valid: false,
      reason: `Event name cannot start with reserved prefix (${RESERVED_PREFIXES.join(", ")}).`,
    };
  }

  return { valid: true };
}

export function validateAnalyticsParamKey(paramKey: string): EventNameValidationResult {
  if (!PARAM_KEY_REGEX.test(paramKey)) {
    return {
      valid: false,
      reason:
        "Param name must be snake_case, start with a lowercase letter, and be <= 40 chars.",
    };
  }

  if (RESERVED_PREFIXES.some((prefix) => paramKey.startsWith(prefix))) {
    return {
      valid: false,
      reason: `Param name cannot start with reserved prefix (${RESERVED_PREFIXES.join(", ")}).`,
    };
  }

  return { valid: true };
}
